import { httpRequest_001, httpRequest_002, httpRequest_003 } from "./Axios";
export const VirtualBinDetail_summary_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/VitualBin/WMSVitualBinLoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const VitualBin_WMSVitualBinAttribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/VitualBin/WMSVitualBinAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_locaitonlist_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/locaitonlist`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_BrandSearchgetrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/BrandSearchgetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_SupplierSearchgetrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/SupplierSearchgetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_TransItemStockUOM_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/TransItemStockUOM`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const OS_DETAIL_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/OS_DETAIL_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_summary_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

// export const InventoryPhysicalstock_gridLoad_API = async (apiObj) => {
//   let apiMethod = {
//     method: "POST",
//     url: `/inventory/physicalstock/gridLoad`,
//     data: apiObj,
//   };
//   var Data = await httpRequest_002(apiMethod);

//   return Data;
// };
export const InventoryPhysicalstock_gridLoad_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/GridLoadIPT`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_deleteDetail_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/deleteDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_delete_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/DeleteIPT`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_deleteHead_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/deleteHead`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_saveDetail_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/saveDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_saveHead_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/saveHead`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const InventoryPhysicalstock_save_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/SaveIPT`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const RpDesign_getGitterColumns_trnTyp_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "GET",
    url: `/RpDesign/getGitterColumns?trnTyp=${apiObj}`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const RpDesign_binsearch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RpDesign/binsearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const dcrequest_DCItemPriority_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCItemPriority`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_groupstructure_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/groupstructure`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_brandgroup_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/brandgroup`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_brandbasedgroup_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/brandbasedgroup`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_LocationSearch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/LocationSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_DcRebateDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/DcRebateDetail_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_BuyerList_GETROW = async () => {
  let apiMethod = {
    method: "POST",
    url: `/common/BuyerList`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_BinAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/BinAttributes`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_UserLoading_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/UserLoading`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_ItemsAnalsys_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/ItemsAnalsys`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_VendorListReport_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/VendorListReport`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_CustomerListReport_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/CustomerListReport`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const common_ItemsSearchReport_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/ItemsSearchReport`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const Reports_BinwiseStock_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Reports/BinwiseStock`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_WMSMISAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/WMSMISAttributes`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_PendingDOAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/PendingDOAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_WMStransDetailAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/WMStransDetailAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_WMSBinTransferReportAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/WMSBinTransferReportAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestTransAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestTransAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const DCRequest_DCGroupSearchTyp_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCGroupSearchTyp`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestLoadGrid_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestLoadGrid`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestSaveHead_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestSaveHead`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestSaveDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestSaveDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const DCRequest_DCRequestDelete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestItemsDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestItemsDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestApprove_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestApprove`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DCRequest_DCRequestSearch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const DCRequest_DCRequestReverse_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/dcrequest/DCRequestReverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const LoadingList_LoadingListAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/LoadingListAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DOReceiving_DoReceivingAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/DOReceiving/DoReceivingAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSStockTransfer_getStockEnquiry_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSStockTransfer/getStockEnquiry`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSStockTransfer_WMSStockTransferAttributes_GETROW = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSStockTransfer/WMSStockTransferAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const stockAdjustment_stockAdjustmentAttributes_GETROW = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/stockAdjustment/stockAdjustmentAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSGRV_GRVAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/GRVAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSInbound_grnAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/grnAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSInbound_validateReceivingPost_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/validateReceivingPost`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMSInbound_ReverseWMINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ReverseWMINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSInbound_deleteHeadWMINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteHeadWMINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSInbound_deleteDetailWMINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteDetailWMINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSInbound_validationWMINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/validationWMINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const WMSInbound_ConfirmWMINV03LineItem_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ConfirmWMINV03LineItem`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};

export const WMSInbound_ApproveWMINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};

export const WmsSI_wmsSalesInvoiceAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsSI/wmsSalesInvoiceAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_invTransDetailBatchIssue_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/invTransDetailBatchIssue`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_batchDetailGetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/batchDetailGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_updateDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_deleteDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_getDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_UpdateRMADetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/UpdateRMADetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PO_Division_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/DivisionLoading`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_getRMiDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getRMiDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_deleteRMADetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteRMADetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv05_SalesQuotationAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const validationINV05_SalesQuotation_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV05`,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveINV05_SalesQuotation_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV05`,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Load_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Display_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Discount_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_HistoryGrid_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05LoadVendorData`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_Reverse_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesQuotation_sopstockdetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/sopstockdetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv05_SalesOrder_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv05_SalesOrder_SOPDetailStockValidation_GETROW = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/SOPDetailStockValidation`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesOrder_ValidationINV06_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ValidationINV06`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesOrder_getCustomerPriceLevel_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getCustomerPriceLevel`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesOrder_ApproveINV06_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV06`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};

export const inv05_SalesOrder_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv05_SalesOrder_QuotationSearch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv05RefDocSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv05_SalesOrder_Discount_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06Discount`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_Display_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_Load_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_Reverse_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_PIQuotationHead_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06PendingPIHead`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_PIQuotationDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06PendingPIDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_PIQuotationNext_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06PendingPINext`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv05_SalesOrder_HistoryGrid_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv06LoadVendorData`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/StktrnsAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const EasyPutAway_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/General/app`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/INV10RSumGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_SaveDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/INV10RSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_DeleteDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/INV10RDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/INV10RLoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const StockTransferReceipt_ApproveDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/invtrans/INV10RApprove`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SalesInvoice_Attribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SalesInvoice_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SalesInvoice_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SalesInvoice_Display_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Display`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_Discount_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08DisCal`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_TransTermsLoadDefault = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/TransTermsLoadDefault`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_TransTermsDelete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/TransTermsDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_TransTermsUpdate = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/TransTermsUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_getVoucherDetails = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getVoucherDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSloading_LoadingDelete001 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/LoadingDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_Reverse_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_ACBelowFixedPrice_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08ACBelowFixedPrice`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_getTransPdf = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getTransPdf`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_TransISDocUpdate = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/TransISDocUpdate`,
    data: apiObj,
    // headers: {
    //   "Content-Type": "multipart/form-data", // Ensure the correct content type
    // },
  };
  console.log(apiObj);

  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_ACNegativeStock_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08ACNegativeStock`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_ACAddedWarranty_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08ACAddedWarranty`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_ACAmc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08ACAmc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_inv08demanditemqtyvalidation_GETROW = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08demanditemqtyvalidation`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice_inv08LoadVendorData_GETROW = async (
  apiObj,
  loader
) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08LoadVendorData`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod, loader);

  return Data;
};
export const SalesInvoice_inv08RefDocSearch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/inv08RefDocSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SalesInvoice001_ValidationInv08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ValidationInv08`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_saveInv08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv08`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_shipmentAddress = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/shipmentAddress`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_shipmentGetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/shipmentGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_Custom = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Custom`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_CustomGetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/CustomGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_Reverse001 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Reverse001`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_DespatchDetail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/DespatchDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_DespatchGetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/DespatchGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_Loyalty_Search_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Loyalty_Search_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_Loyalty_Search_Getrow_FULL = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Loyalty_Search_Getrow_FULL`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_DetailAddressDropdown = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/DetailAddressDropdown`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_SubKontenAddress_Detail_GetRow = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/SubKontenAddress_Detail_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SalesInvoice001_ValidateApprove001 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ValidateApprove001`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const common_AccountPostingDetail_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/common/AccountPostingDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WmsInbound_getPendingPo_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/getPendingPo`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WmsInbound_getPallet_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/getPallet`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_LocationwiseStock_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/LocationwiseStock`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSIInbound_WMINV03RSPMSPDetail_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/WMINV03RSPMSPDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSIInbound_WMINV03MSPSave_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/WMINV03MSPSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_LinkDocument_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/WMINV08LinkedDocs`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const picking_PickingSumry_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/PickingSumry`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const picking_PickingGetrow_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/PickingGetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const picking_PickingApprove_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/PickingApprove`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const Lutfi_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/FactTransSync/FactTransAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Lutfi_Summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/FactTransSync/FactTransSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Lutfi_Sync_Summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/FactTransSync/FactTransSummary_001`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Lutfi_Update_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/FactTransSync/FactTransUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Notification_PickQty_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/NotificationPickQty`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const PendingSummary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsPutaway/easyPutAwayPending`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const easyPutAwayCardIdSummary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsPutaway/easyPutAwaySummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/LoadVersionAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_NewTrip_Create = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/NewTrip_Create`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_LoadTripsByDateRange = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/LoadTripsByDateRange`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_UpdateTripPostingStatus = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/UpdateTripPostingStatus`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_EasyLoading_Truckid_dependency = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoading_Truckid_dependency`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVersion_LH_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingVersion`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoading_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoading`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingUpdate_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingDelete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingBarcode_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingBarcode`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingPost_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingPost`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyLoadingVariance_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/EasyLoadingVariance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyBinTransfer_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BinTransfer/EasyBinTransferSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyBinTransfer_Src = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BinTransfer/EasyBinTransferUpdateSrc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyBinTransfer_Des = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BinTransfer/EasyBinTransferUpdateDes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const EasyBinTransfer_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BinTransfer/EasyBinTransferDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Item_Search = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RpDesign/searchItems001`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Bin_Attribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Bin_Load_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSBinLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Bin_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSBinDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Bin_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSBinSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Driver_Attribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSDriverAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Driver_Load_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSDriver_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Driver_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSDriverDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Driver_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSDriverSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Truck_Attribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSTruckAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Truck_Load_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSTruckLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Truck_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSTruckDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Truck_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSBin/WMSTruckSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const physicalstock_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_AssignBinLoad = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_AssignBinLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Assign_Save = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Assign_Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_New_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_New_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_New_Approve = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_New_Approve`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_New_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_New_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_New_Save = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_New_Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Assign_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Assign_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const PhysicalStockCount_New_Attribute = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_New_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Assign_Approve = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Assign_Approve`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Assign_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Assign_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Count_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStock_Summary_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStock_Detail_Load = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStock_Detail_Load`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Physical_Stock_Count_Save = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/Physical_Stock_Count_Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Physical_Stock_Count_Approve = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Count_Approve`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Count_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Count_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Count_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Count_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const PhysicalStockCount_Count_binsearch = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/Physical_Stock_Count_BinSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Summary_Attribute = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Summary_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Variance_Counting = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "GET",
    url: `/physicalstock/PhysicalStockCount_Variance_Counting?A_RefNo=${apiObj.A_RefNo}&A_Loc=${apiObj.A_Loc}&isPending=${apiObj.isPending}`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Variance_Comparision = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "GET",
    url: `/physicalstock/PhysicalStockCount_Variance_Comparision?v_A_RefNo=${apiObj.v_A_RefNo}&A_Loc=${apiObj.A_Loc}`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Variance_Generate = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Generate_Variance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_Post_Generate = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_Post_Variance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PhysicalStockCount_onLoad_Attribute = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/PhysicalStockCount_onload_Attribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Audit_Data_Load = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/RpDesign/transAudit`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Audit_Arr = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "GET",
    url: `/RpDesign/auditFields?trnTyp=${apiObj.trnTyp}`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SUBKONTEN_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "GET",
    url: `/General/SUBKONTEN`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const Division_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "GET",
    url: `/General/Division`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const LocationWithandWithoutRights_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/General/LocationWithandWithoutRights`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const SliceData_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/General/SliceData`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const Get_Delivery_Summary = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliverySummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Get_Delivery_ItemList = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliveryItemList`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Delivery_ItemList_Save = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliverySave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Delivery_ItemList_Post = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliveryPost`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Delivery_ItemList_load = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliveryLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Delivery_ItemList_Delete = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/delivery/deliveryDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
//InboundProcessFlow_GETROW
export const common_InboundProcessFlow_GETROW = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/common/InboundProcessFlow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_PutAwayBinMismatch_GETROW = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/common/PutAwayBinMismatch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_EmptyBin_GETROW = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/common/EmptyBin`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_DispatchDetail_GETROW = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/common/dispatchDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const common_DispatchDetail_Attributes = async (apiObj) => {
  console.log(apiObj);
  let apiMethod = {
    method: "POST",
    url: `/common/DispatchDetail_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
//cycle count start
export const CycleCount_summary_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPSCCSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const CycleCount_save_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/updateOrInsertWMPSCC`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const CycleCount_delete_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/deleteWMPSCC01B`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const CycleCount_approve_var_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPSCC_Stock_Transfer`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const CycleCount_print_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPSCCVariance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const CycleCount_BRow_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/getWMPSCC01BRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
//cycle count end

export const GRNNormal_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV03_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Grn_ConfirmINV03LineItem_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/confirmINV03LineItems`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const GRNNormal_fINV02_Head_Detail_Barcode_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_Head_Detail_Barcode`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const fINV06_Head_Detail_Barcode_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV06_Head_Detail_Barcode`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const GRNNormal_validationINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveconfirmationINV03 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveconfirmationINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const GRNNormal_ApproveINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};

export const GRNNormal_InvTransReverseINV03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/InvTransReverseINV03`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_INV03_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV03_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_fINV03_fDiscCalc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV03_fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_fINV03_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV03_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_fINV03_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV03_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_INV03_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV03_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_saveInv03_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv03`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_RefDocumentType_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/RefDocumentType`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const GRNNormal_RefDocumentNo_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/RefDocumentNo`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_BUYER_GETROW_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/BUYER_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_Inv03CgetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Inv03CgetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_deleteInv03CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteInv03CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_updateInv03CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateInv03CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_NextSrNoInv03C_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/NextSrNoInv03C`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_generateBatchNo_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/generateBatchNo`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_FreightUpdate_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/FreightUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GRNNormal_INV03D_GetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV03D_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INV05_StockSetupGetrow_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/StockSetupGetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INV05_StockSetupUpdate_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/StockSetupUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INV05_GetItemSupplierDetails_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/GetItemSupplierDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

//GRV
export const inv04_validationINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv04_ApproveINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv04_InvTransReverseINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/InvTransReverseINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_fINV04_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV04_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_BUYER_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/BUYER_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_INV04_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV04_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_fINV04_fDiscCalc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV04_fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_fINV04_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV04_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_fINV04_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV04_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_INV04_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV04_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv04_saveInv04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_RefDocumentType_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/RefDocumentType`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_RefDocumentNo_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/RefDocumentNo`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INV10R_SearchDocument = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10R_SearchDocument`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_Inv04CgetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Inv04CgetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_updateInv04CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateInv04CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv04_deleteInv04CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteInv04CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_validationINV09_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV09`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv09_ApproveINV09_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV09`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv09_ReverseINV09_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ReverseINV09`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_AttributesINV09_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV09`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_INV09_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV09_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_fINV09_fDiscCalc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV09_fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_fINV09_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV09_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_fINV09_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV09_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_INV09_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV09_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_saveInv09_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv09`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv09_Inv09CgetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Inv09CgetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_deleteInv09CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteInv09CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_updateInv09CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateInv09CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_NextSrNoInv09C_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/NextSrNoInv09C`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_INV09UpdateRMADetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV09UpdateRMADetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_INV09getRMiDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV09getRMiDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv09_INV09deleteRMADetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV09deleteRMADetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SegregationSummary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/SegregationSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SegregationLocation_Detail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/SegregationLocation_Detail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SegregationLocation_Pending_Detail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/SegregationLocation_Pending_Detail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SegregationDetail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/SegregationDetail_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLSTLI_Update_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/WMPKLSTLI_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLSTLI_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/WMPKLSTLI_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Segregation_DropID_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/Segregation_DropID_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLSTLI_Delete_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/WMPKLSTLI_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv10_validationINV10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV10`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
// Approve INV10
export const inv10_ApproveINV10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV10`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);
  return Data;
};

// Reverse INV10
export const inv10_ReverseINV10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ReverseINV10`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Attributes INV10
export const inv10_AttributesINV10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV10`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// INV10R Search Document
export const inv10_INV10R_SearchDocument_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10R_SearchDocument`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// INV10 Search
export const inv10_INV10_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// INV10 fDisplay
export const inv10_fINV10_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV10_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// INV10 Delete
export const inv10_INV10_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// INV10 Load Detail
export const inv10_INV10_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Save INV10
export const inv10_saveInv10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv10`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
//INV10RDropId
export const inv10_INV10RDropId_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10RDropId`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const inv10_INV10ExcelImport_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10ExcelImport`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const inv10_fINV10R_A_RefID_GetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV10R_A_RefID_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
// Update INV10C Details
export const inv10_updateINV10CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateINV10CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Delete INV10C Details
export const inv10_deleteINV10CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteINV10CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Get INV10C Details
export const inv10_getINV10CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getINV10CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
// Get INV10C Row
export const inv10_Inv10CgetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Inv10CgetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Delete INV10C Row
export const inv10_deleteInv10CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteInv10CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

// Update INV10C Row
export const inv10_updateInv10CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateInv10CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const inv10_Location_INVTrans_INV10_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Location_INVTrans_INV10`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const itemEnquiry_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/itemEnquiry`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const itemEnquiryAttributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/itemEnquiryAttributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const WHPicking_Summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WHPicking/Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const WHPicking_Complete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WHPicking/Complete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const WHPicking_save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WHPicking/save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const WHPicking_Detail_GetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WHPicking/Detail_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const WHPicking_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WHPicking/Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const DropIdEnquiry_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/segregation/DropIdEnquiry`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const BarcodeScanningUpdate_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/BarcodeScanningUpdate`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const BarcodeScanningGetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/BarcodeScanningGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const BarcodeScanningDelete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/BarcodeScanningDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const inv11_validationINV11_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV11`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv11_Approve_INV11_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Approve_INV11`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv11_ReverseINV11_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ReverseINV11`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_AttributesINV11_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV11`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_INV11_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV11_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_fINV11_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV11_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_INV11_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV11_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_INV11_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV11_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_save_INV11_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/save_INV11`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_updateINV11CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateINV11CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_deleteINV11CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteINV11CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_getINV11CDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getINV11CDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_Inv11CgetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Inv11CgetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_deleteInv11CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteInv11CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv11_updateInv11CRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateInv11CRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv07_InvTransDetailSummary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/InvTransDetailSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INV12_GetStockDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12_GetStockDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const inv07_ValidationINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ValidationINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv07_ApproveINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv07_ReverseINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ReverseINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_AttributesINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_INV07_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV07_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_fINV07_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV07_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_fINV07_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV07_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_INV07_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV07_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_saveInv07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveInv07`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv07_updateINV07Details_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/updateINV07Details`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_deleteINV07Details_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteINV07Details`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_getINV07Details_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getINV07Details`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_UpdateRMADetailsINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/UpdateRMADetailsINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_getRMiDetailsINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getRMiDetailsINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_deleteRMADetailsINV07_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/deleteRMADetailsINV07`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_fINV07_fDiscCalc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV07_fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv07_fLoadPODetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fLoadPODetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_validationINV02_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV02`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv02_ApproveINV02_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV02`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv02_InvTransReverseINV02_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/InvTransReverseINV02`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV02_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV02_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV02_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV02_fDiscCalc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_fDiscCalc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV02_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV02_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV02_Multiselect_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV02_Multiselect_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV02_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV02_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

// export const ItemsHistory_API = async (apiObj) => {
//   let apiMethod = {
//     method: "POST",
//     url:`/inv05/ItemsHistory`,
//     data: apiObj,
//   };
//   var Data = await httpRequest_002(apiMethod);

//   return Data;
// };
export const inv02_SaveINV02_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/SaveINV02`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_validationINV12_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV12`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv02_ApproveINV12_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ApproveINV12`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const inv02_ReverseINV12_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ReverseINV12`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12ABrAlloc_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12ABrAlloc_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12ABrAlloc_Update_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12ABrAlloc_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12ABrAlloc_Delete_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12ABrAlloc_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_AttributesINV12_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV12`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12_Search_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12_Search`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_fINV12_fDisplay_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fINV12_fDisplay`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12_Delete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_INV12LoadRefDoc_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV12LoadRefDoc`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const inv02_save_INV12_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/save_INV12`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const StockSetupReason_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/StockSetupReason`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INV06_MOBILE_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/GetINV06QSCustomerRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ORDER_DETAIL_GETROW_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/GetINV06QSBRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ORDER_DELIVERY_POST_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/SaveINV06QS_Delievry`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INVBTOUT_Summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/batchDispatchDocumentGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_Attribute_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/PendingBatchattributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_batchDetailSrNoGetRow_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/batchDetailSrNoGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_updateBatchDispatch_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/updateBatchDispatch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INVBTOUT_batchDispatchDetailApprove_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/batchDispatchDetailApprove`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_batchDispatchDetailDelete_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/batchDispatchDetailDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INVBTOUT_getDispatchDetailsForGrid_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/getDispatchDetailsForGrid`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_getInv04VersionDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/getInv04VersionDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_getBatchDispatchDetails_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/getBatchDispatchDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const INVBTOUT_getBatchDispatchVariance_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/BatchSummary/getBatchDispatchVariance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMSDashBoard_Summary_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/WMSDashBoardLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const AttributePutAway = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/AttributePutAway`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAwaySummary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAwaySummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMINV03BinGetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/WMINV03BinGetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAwayHeadDetails = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAwayHeadDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_PendingPO_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_PendingPO_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_PendingRCV_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_PendingRCV_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_POVarience_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_POVarience_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G2_PendingPutAway_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G2_PendingPutAway_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G2_PendingPutAwayDetail_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G2_PendingPutAwayDetail_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G3_PendingPicking_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G3_PendingPicking_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G4_PendingEnter_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G4_PendingEnter_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G5_PickingProgress_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G5_PickingProgress_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMSDashBoard_TransactionDetail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/TransactionDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_Generation_Attributes = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_Generation_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_PutAwayValidation = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAwayValidation`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_Save = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_Post = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_Post`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_MultiUserGetrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_MultiUserGetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SavePutAwayUserAssignment = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/SavePutAwayUserAssignment`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_DOCUMENTNO_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_DOCUMENTNO_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const PutAway_GetStatusDetails = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/PutAway_GetStatusDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G5_PickingProgressDetail_LoadDetail_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G5_PickingProgressDetail_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_PendingPO_Attributes_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_PendingPO_Attributes`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_PendingPO_Save_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_PendingPO_Save`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_PendingPO_ValidateInvExistence_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/ValidateInvoiceExistence`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_LoadVersion_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_LoadVersion`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const getPurchaseGrnVariance_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/getPurchaseGrnVariance`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_POPending_POST_REVERSE_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_POPending_POST_REVERSE`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const G1_POPending_DELETE_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/G1_POPending_DELETE`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GetUnbayLoad_Receiver_User_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/GetUnbayLoad_Receiver_User`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const getSalesDocForSalesReturn_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSDashBoard/getSalesDocForSalesReturn`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_Evaluation_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluation_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationHead_POST = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationHead_POST`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationDetail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationDetail_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const HRMonthly_EvaluationHead_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationHead_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const HRMonthly_EvaluationRating_List_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationRating_List_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationHead_Confirm_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationHead_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationHead_CONFIRM_STATUS_Update = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationHead_CONFIRM_STATUS_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_Evaluation_Update_CONFIRM = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluation_Update_Confirm`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationHead_POST_CONFIRM = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationHead_POST_Confirm`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationDetail_GetRow_CONFIRM = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationDetail_GetRow_Confirm`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const HRMonthly_EvaluationRating_List_GetRow_CONFIRM = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluationRating_List_GetRow_Confirm`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const HRMonthly_Review_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluation_Report_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const HRMonthly_Review_Atrributes = async () => {
  let apiMethod = {
    method: "GET",
    url: `/HRJobTitle/AttributesHRJobTitle`,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const HRMonthly_Appraisal = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/HRMonthlyEvaluation_Salary_Appraisal_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const validationWMINV03_VENDOR_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/validationWMINV03_VENDOR`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ConfirmWMINV03LineItem_VENDOR_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ConfirmWMINV03LineItem_VENDOR`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03_VENDOR_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03_VENDOR`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03confirm_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03confirm_VENDOR`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const validationWMINV03_Return_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/validationWMINV03_Return`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03_Return_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03_Return`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03confirm_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03confirm_Return`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const validationWMINV03_Outlet_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/validationWMINV03_Outlet`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03_Outlet_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03_Outlet`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV03confirm_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/ApproveWMINV03confirm_Outlet`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const MobileCoupon_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/MobileCoupon_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const MobileCoupon_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/MobileCoupon_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const MobileCoupon_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/MobileCoupon_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const MobileCoupon_MobileNumberSearch = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/HRJobTitle/MobileCoupon_MobileNumberSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const BoxPallet_Pending_Report = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsBoxPallet/BoxPallet_Pending_Trans_Detail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const BoxPallet_Report = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsBoxPallet/getBoxPalletDetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const BoxPallet_Ledger_Report = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WmsBoxPallet/BoxPallet_Ledger_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const BoxPallet_searchExactItemAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RpDesign/searchExactItem`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const saveHead_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveHead_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const saveDetail_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveDetail_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const getDetails_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/getDetails_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const deleteHeadWMINV03_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteHeadWMINV03_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const deleteDetailWMINV03_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteDetailWMINV03_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

// grn_Return
export const Attributes_WmsInboundReturn = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/Attributes_WmsInboundReturn`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const saveHead_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveHead_Return`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const saveDetail_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveDetail_Return`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const getDetails_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/getDetails_Return`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const deleteHeadWMINV03_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteHeadWMINV03_Return`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const deleteDetailWMINV03_Return = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteDetailWMINV03_Return`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

// grn_Outlet
export const Attributes_WmsInboundOutlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/Attributes_WmsInboundOutlet`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const FetchReason_WmsInboundOutlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/FetchReason_WmsInboundOutlet`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const FetchReason_WmsInboundReturn = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/FetchReason_WmsInboundReturn`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const saveHead_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveHead_Outlet`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const saveDetail_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/saveDetail_Outlet`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const getDetails_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/getDetails_Outlet`,
    data: apiObj,
  };
  return await httpRequest_001(apiMethod);
};

export const deleteHeadWMINV03_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteHeadWMINV03_Outlet`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const deleteDetailWMINV03_Outlet = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/deleteDetailWMINV03_Outlet`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const Loading_Box_PalletId_Grid_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `WmsBoxPallet/getDetailWMLDLSTI`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const Loading_Box_PalletId_Save_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `WmsBoxPallet/updateDetailWMLDLSTI`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const AttributesBoxPalletTruck = async () => {
  let apiMethod = {
    method: "POST",
    url: `/WmsBoxPallet/BoxPalletTruck_Loading`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Loading_Box_PalletId_Delete_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `WmsBoxPallet/deleteDetailWMLDLSTI`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Loading_Box_PalletId_Barcode_Scan_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `WmsBoxPallet/getBarcodeDetailScanBasket`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const RSPUpdate_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/RSPUpdate_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const updateInvTransManualListing_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/updateInvTransManualListing_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxAddRemove_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxAddRemove_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxConvertUpdate_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxConvertUpdate_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const UpdateRefFields_VENDOR = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/UpdateRefFields_VENDOR`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

// RETURN
export const RSPUpdate_RETURN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/RSPUpdate_RETURN`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const updateInvTransManualListing_RETURN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/updateInvTransManualListing_RETURN`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxAddRemove_RETURN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxAddRemove_RETURN`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxConvertUpdate_RETURN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxConvertUpdate_RETURN`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const UpdateRefFields_RETURN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/UpdateRefFields_RETURN`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

// OUTLET
export const RSPUpdate_OUTLET = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/RSPUpdate_OUTLET`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const updateInvTransManualListing_OUTLET = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/updateInvTransManualListing_OUTLET`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxAddRemove_OUTLET = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxAddRemove_OUTLET`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const TaxConvertUpdate_OUTLET = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/TaxConvertUpdate_OUTLET`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const UpdateRefFields_OUTLET = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/UpdateRefFields_OUTLET`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const validationINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/validationINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const approveINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/approveINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const reverseINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/reverseINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const searchINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/searchINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const getINV10REQDetails = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getINV10REQDetails`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const INV10REQDelete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10REQDelete`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const getINV10RBRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/getINV10RBRow`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const saveINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/saveINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const AttributesINV10REQ = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/AttributesINV10REQ`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const CRAppPromotionsSummary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/CRAppPromotions/crAppPromotionsSummary`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const AppPromotionsGetFiles = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/CRAppPromotions/CRAppPromotionsGetFiles`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};
export const CRAppPromotionsUpdate = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/CRAppPromotions/CRAppPromotionsUpdate001`,
    data: apiObj,
  };
  return await httpRequest_002(apiMethod);
};

export const PendingPODetail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/PendingPODetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const saveGetPendingPoDetails = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/savePendingPODetails`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INV10_Request_Variance_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10_Request_Variance_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const Stock_Enquiry_All_Loc_Stock = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/Stock_Enquiry_All_Loc_Stock`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const DMS_Vendor = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSInbound/DMS_Vendor`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const AttributesStockSetup = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/AttributesStockSetup`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ItemsSetupAudit001_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ItemsSetupAudit001_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const Update_ItemsSetup_From_Audit = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/Update_ItemsSetup_From_Audit`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const INV10Request_LoadDetail = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/INV10Request_LoadDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SaveINV10BDetails_FromReq = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/SaveINV10BDetails_FromReq`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ValidateINV10BDetails_FromReq = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ValidateINV10BDetails_FromReq`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ConfirmAndSaveINV10BDetails_FromReq = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/ConfirmAndSaveINV10BDetails_FromReq`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const TruckDetailsGetrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/TruckDetailsGetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const TruckDriverDetailsGetrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/TruckDriverDetailsGetrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMLDLSTA_TruckDriver_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/WMLDLSTA_TruckDriver_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMLDLSTATruck_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSloading/WMLDLSTATruck_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMS_Po_Variance_Getrow_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPOIPT00A_VARIANCE_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const WMS_Po_Variance_Post_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPOIPT_Stock_Transfer`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMS_Po_Reverse_Variance_Post_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/physicalstock/WMPOIPT01_VARIANCE_REVERSAL
`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const ISTCRA_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ISTCRB_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRB_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const ISTCR_Reason_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCR_Reason_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const ISTCRA_ISTCRB_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_ISTCRB_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const SPL_PromoCouponHead_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/cyclicCount/SPLPromoCouponHead_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const RSPCRA_SummaryApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSPCRA_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const SPL_PromoCouponHead_Detail_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/cyclicCount/SPLPromoCouponHead_Detail_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const SPL_PromoCouponDetail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/cyclicCount/SPLPromoCouponDetail_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const SPL_PromoCouponDetail_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/cyclicCount/SPLPromoCouponDetail_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCR_Items_Master_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCR_Items_Master_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCRA_Confirm_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCRA_Confirm_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_Confirm_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCRB_Approve_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRB_Approve_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const getReasonAttribute = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RejectAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISA_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISA_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMOQCRA_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRA_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISB_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRB_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRB_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRB_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRB_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCRA_ISTCRB_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_ISTCRB_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISC_Items_Master_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISC_Items_Master_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCR_Items_Master_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCR_Items_Master_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const validationWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/validationWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/ApproveWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SaveWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/SaveWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const deleteHeadWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/deleteHeadWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const deleteDetailWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/deleteDetailWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const ReverseWMINV04_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/WMSGRV/ReverseWMINV04`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const VNDRDISA_VNDRDISB_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISA_VNDRDISB_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRA_ILSTCRB_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRA_ILSTCRB_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRA_IMOQCRB_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRA_IMOQCRB_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISA_VNDRDISB_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRB_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRB_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRB_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRB_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISB_Barcode_List_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Barcode_List_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSPCRA_RSPCRB_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSPCRA_RSPCRB_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSPCRA_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSPCRA_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSP_Competitor_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSP_Competitor_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSPCRB_DELETE = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSPCRB_DELETE`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSPCRB_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSPCRB_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSP_Reason_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSP_Reason_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const RSP_Status_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/RSP_Status_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRA_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRA_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISB_Items_Discontinue_Status_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Items_Discontinue_Status_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRB_Items_Listing_Status_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRB_Items_Listing_Status_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRB_Items_MOQ_Status_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRB_Items_MOQ_Status_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISA_Confirm_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISA_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRA_Confirm_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRA_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRA_Confirm_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRA_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISB_Confirm_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Confirm_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRB_Confirm_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRB_Confirm_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISB_Approve_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISB_Approve_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRB_Approve_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRB_Approve_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRB_Confirm_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRB_Confirm_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRB_Approve_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRB_Approve_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ISTCRA_REVERSE = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ISTCRA_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const VNDRDISA_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/VNDRDISA_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const ILSTCRA_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ILSTCRA_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMOQCRA_Reverse = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/IMOQCRA_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const fUnitPriceOnChangePO = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fUnitPriceOnChangePO`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const fUnitPriceOnChangeGRV = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fUnitPriceOnChangeGRV`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const fUnitPriceOnChangeGRN = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inv05/fUnitPriceOnChangeGRN`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
//salesInvoice
export const validationWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/validationWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const ApproveWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/ApproveWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_003(apiMethod);

  return Data;
};
export const SaveWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/SaveWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const deleteHeadWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/deleteHeadWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const deleteDetailWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/deleteDetailWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const ReverseWMINV08 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/wmsSI/ReverseWMINV08`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const GET_API_LOGINAttribute = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `General/LoginAttribute`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const GET_API_ZATCA_TRANSACTION_SUMRY = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Zatca/transactionSummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const GET_API_ZATCA_TRANSACTION_DETAIL = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Zatca/transactionDetail`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const GET_API_ZATCA_TRANSACTION_DETAIL_ROW_JSON = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Zatca/transactionDetailJSON`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};

export const GET_API_RSP_Change_Approve_Summary_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCRA_Confirm_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Approve_Detail_Summary_GetRow = async (
  apiObj
) => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCRB_Confirm_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Approve_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCRB_Approve_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Approve_Reason_GetRow = async () => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSP_Reason_Getrow`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Request_Basket_GetRow = async () => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCR_BK_Active_Getrow`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Request_Basket_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCR_BK_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPUR01A_SummaryApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPUR02B_GETROWApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR02B_GETROW`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Head_GeneratedApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/Import_001_Head_Generated`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPUR01A_DeleteApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Delete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPUR02B_UpdateApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR02B_Update_001`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Import_Purchase_Summary_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Purchase_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Close__Summary_Detail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Purchase_Analysis_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Summary_Detail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Purchase_Vs_Order`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Summary_Post = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Purchase_POST`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Version_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPURPURA_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Detail_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPURPURB_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Detail_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPURPURA_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const Purchase_RequestCloseApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Close_POST`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Reopen = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Purchase_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const GET_API_RSP_Change_Approve_Reject_Type_GetRow = async () => {
  let apiMethod = {
    method: "POST",
    url: `Master/RSPCR_Reject_Reason_Getrow`,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Division_SubKoten = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `General/SubKontenSalesMan`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const SubKonten_Search_Full_V3Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `General/SubKonten_Search_Full_V3`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Direct_Price_Change_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Master/ItemLageYunits_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPUR01A_Planning_ReverseAPi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPUR01A_Planning_Reverse`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_ITEMS_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_ITEMS_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Head_SaveApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Head_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Pages_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Pages_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Category_Item_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Category_Item_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_ITEMS_UpdateApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_ITEMS_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const PAP_Head_PostApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Head_Post`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const PAP_Locations_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Locations_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Locations_Save = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Locations_Post`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Item_Pages_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Item_Pages_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Head_Attri_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Head_Attri_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};



export const QuickSale_PAP_ACTIVITY_GETROW = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_ACTIVITY_GETROW`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const QuickSale_PAP_ACTIVITY_Update= async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_ACTIVITY_Update`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const QuickSale_PAP_Head_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Head_Summary`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Items_Search_PAP_GetRowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/Items_Search_GetRow_WB_PAP`,
    data: apiObj,
  }
  var Data = await httpRequest_002(apiMethod);
  return Data;
}

export const PAP_Head_PDF_SaveApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Head_PDF_Save`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Pages_Verify_UpdateApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Pages_Verify_Update`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Head_Attri_Post = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Head_Attri_Post`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Design_Items_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Design_Items_Getrow`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PackingUnit_Buyer_getrowsAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PackingUnit_Buyer_getrows`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Pages_Insert = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/Add_Pages_Insert`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Pages_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Pages_Update`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Pages_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Pages_Delete`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Category_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Category_Update`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Category_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Category_Getrow`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Category_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Quicksale/PAP_Category_Delete`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURTrip_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURTrip_Summary`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURTrip_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURTrip_Update`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURTrip_POST = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURTrip_POST`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Active_TripId_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/Active_TripId_Getrow`,
     data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const BrClassification_GetApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/BrClassification_Getrow`,
    data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const BrClassification_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/BrClassification_Update`,
    data: apiObj,
  }
   var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const StockSetupTemplate_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/StockSetupTemplate_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

//neww 
export const StockSetupDaysTemplate_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/StockSetupDaysTemplate_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Dept_Brcls_AttriApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/Dept_Brcls_Attri`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const StockSetupTemplate_UpdateApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/StockSetupTemplate_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
//new add StockSetupDaysTemplate_Update
export const StockSetupDaysTemplate_UpdateApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/StockSetupDaysTemplate_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};





export const IMPUR01A_Pur_Status_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPUR01A_Pur_Status_Delete`,
        data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemMSP_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `ItemsMSP/ItemsMSP_LoadGrid_002_WB`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Search_Exact_ItemAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RpDesign/searchExactItem`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const AddiWarranty_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/AddiWarranty_Getrow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const AddiWarranty_SaveApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `Master/AddiWarranty_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemMSP_Save_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/ItemsMSP/ItemsRSP_MSP_Update`,
     data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
export const IMPURTrip_Summary_001 = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURTrip_Summary_001`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURItemA_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURItemA_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const Purchase_IMPURItemB_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPURItemB_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_IMPURItem_Head_Detail_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURItem_Update`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_Validate_ExcelItems = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/ValidateExcelItems`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Purchase_IMPURItem_POST = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/ValidateAndApproveExcelItems`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemMSP_Location_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/ItemsMSP/ItemsMSP_Attributes`,
     data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURItem_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/RPurchase/IMPURItem_Delete`,
     data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const IMPURItemsB_Excel_Format_PO = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPURItemsB_Excel_Format_PO`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const Trip_Deactivate_All_Count_GetRow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/All_Count_GetRow`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const Trip_IMPUR01A_Close_Summary = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `RPurchase/IMPUR01A_Close_Summary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const WMPKLSTA_Summary_GetRow_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTA_Summary_GetRow`,
    data: apiObj,
    headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLST_SALES_GROUP_LIST_DEVEXPRESS_WBS_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_SALES_GROUP_LIST_DEVEXPRESS_WBS`,
    data: apiObj,
    headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLST_Document_Typ_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_Document_Typ`,
    data: apiObj,
    headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};
export const WMPKLST_ATTRI_GETROW_API = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_ATTRI_GETROW`,
    data: apiObj,
    headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);

  return Data;
};



export const PickingList_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_GENERATE_001_reference_Getrow_V2`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};




export const PickingList_PostApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTA_Post_Document`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const PickingList_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTA_WMPKLSTB_UPDATE`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PickingList_Reverse= async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_Reverse_Update`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};




export const PickingList_Delete = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTA_DELETE`,
    data: apiObj,
      headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};



export const Print_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_Print_Getrow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const LoadingBay_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTI_GETROW`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const LoadingBay_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTI_UPDATE`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const BinAllocate_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTH_Getrow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};




export const BinAllocate_Update = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTH_UPDATE`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};




export const BinAllocate_Attri = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_PDT_User_Getrow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const Loading_Bin_Attri = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_Loading_Bin_Getrow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const UserWise_Print_Getrow = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLSTH_User_GetRow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};


export const Allocate_Stock_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/Auto_Picking_generation`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_HEAD_Delete_Api = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_HEAD_Delete`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Brand_Search_GetrowApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Brand_Search_Getrow`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const PAP_Head_Userwise_DeleteApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Head_Userwise_Delete`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const  PAP_Items_DeleteApi = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Quicksale/PAP_Items_Delete`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};




export const  Picking_List_Release = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/Picking/WMPKLST_Release_Update`,
    data: apiObj,
     headers: {
      "Content-Type": "application/json",
      "authorization": `${process.env.REACT_APP_HEADER_AUTHU_KEY}`,
    } ,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};












